import { ButtonProps } from '@mui/material';

import CancelButton from '@/components/atoms/CancelButton';
import LogoutButton from '@/components/atoms/LogoutButton';

import useConfirmDialog from '@/components/organisms/confirmDialog/useConfirmDialog';
import ChatThemeProvider from '@/providers/ChatThemeProvider';

const useConfirmLogoutDialog = () => {
  const confirmDialog = useConfirmDialog(false);
  return {
    open: (props: {
      message?: string;
      title: string;
      okLabel?: string;
      okColor?: ButtonProps['color'];
    }) =>
      confirmDialog.open(
        {
          title: props.title,
          message: props.message,
          actions: [
            <CancelButton
              key="cancal"
              onClick={() => confirmDialog.close(false)}
            />,
            <LogoutButton
              key="logout"
              onClick={() => confirmDialog.close(true)}
              color="primary"
            >
              {props.okLabel}
            </LogoutButton>,
          ],
        },
        (c) => <ChatThemeProvider>{c}</ChatThemeProvider>
      ),
  };
};
export default useConfirmLogoutDialog;
